import React, { useState } from 'react';
import Box from 'core/ui/Box';
import moment from 'moment';
import useSelectors from 'modules/map/useSelectors';
import SFDataTable from 'core/ui/DataTable';
import Typography from 'core/ui/Typography';
import LoaderSm from 'core/ui/LoaderSm';
import { newChannelMembersModule } from 'modules/channelMembers/new';
import { Dialog } from '@material-ui/core';
import Checkbox from 'core/ui/Checkbox';
import { timeZoneName } from 'core/utils/formatters/date';
import AuditedChanges from './AuditedChanges';
import AuditedLogsReport from '.';

const removeColumns = ['tokens', 'uid'];
const mountLogText = (log) => {
  let text = log?.action.toUpperCase();
  text += '\r';

  if (log.action === 'create' || log.action === 'destroy') {
    Object.keys(log?.auditedChanges)
      .filter((x) => !!log?.auditedChanges[x])
      .filter((x) => !removeColumns.find((y) => y === x))
      .forEach((itemColumn) => {
        const item = log?.auditedChanges[itemColumn];

        text += '\r';
        text += `Column: ${itemColumn?.toUpperCase()} `;
        text += `${JSON.stringify(item)}`;
        text += '\r';
      });
  }

  if (log.action === 'update') {
    Object.keys(log?.auditedChanges)
      .filter((x) => !removeColumns.find((y) => y === x))
      .forEach((itemColumn) => {
        const item = log?.auditedChanges[itemColumn];

        text += '\r';
        text += `Column: ${itemColumn?.toUpperCase()} `;
        text += `${JSON.stringify(item[0]) || 'NULL'}`;
        text += ' | ';
        text += `${JSON.stringify(item[1]) || 'NULL'}`;
        text += '\r';
      });
  }

  return text;
};

const TableLogs = ({ loading, logs }) => {
  const loadingRenewMembership = useSelectors(newChannelMembersModule, 'loadingRenewMembership');
  const [modal, setModal] = useState({ open: false });

  const [twentyFourHours, setTwentyFourHours] = useState(false);
  const [utc, setUtc] = useState(false);

  const formatDateTime = (momentObject) =>
    momentObject
      .tz(utc ? 'UTC' : timeZoneName())
      .format(`DD MMM, yy • ${twentyFourHours ? 'HH:mm' : 'hh:mma'} z`);

  const columns = [
    {
      name: 'Object',
      selector: 'auditableId',
      sortable: true,
      cell: (row) => (
        <Box>
          {row.auditableId}-{row?.auditableType}
        </Box>
      ),
    },
    {
      name: 'User',
      selector: (row) => row?.user?.name,
      sortable: true,
      cell: (row) => <Box>{row?.user?.name || 'System'}</Box>,
    },
    {
      name: 'Changes',
      selector: 'auditedChanges',
      sortable: true,
      cell: (row) => <AuditedChanges log={row} setModal={setModal} />,
    },
    {
      name: 'Date/Time',
      selector: 'createdAt',
      sortable: true,
      cell: (row) => formatDateTime(moment(row.createdAt)),
    },
  ];

  return (
    <Box>
      <div className="tw-flex tw-gap-4">
        <Checkbox
          label="24H"
          checked={twentyFourHours}
          onClick={() => setTwentyFourHours((oldTfh) => !oldTfh)}
        />

        <Checkbox label="UTC" checked={utc} onClick={() => setUtc((oldUtc) => !oldUtc)} />
      </div>

      {modal.open && (
        <Dialog
          maxWidth="lg"
          fullWidth
          open={modal?.open}
          onClose={() => setModal({ open: false })}
        >
          <Box p={2}>
            <AuditedLogsReport
              auditableId={modal.auditableId}
              auditableType={modal.auditableType}
            />
          </Box>
        </Dialog>
      )}
      <LoaderSm center loading={loading || loadingRenewMembership} />
      <SFDataTable
        noDataComponent={loading ? null : <Typography m={5}>No Logs</Typography>}
        columns={columns}
        data={logs}
        noHeader
        exportData={logs?.map((row) => ({
          object: `${row.auditableId}-${row?.auditableType}`,
          user: row?.user?.name,
          auditedChanges: mountLogText(row),
          datetime: formatDateTime(moment(row.createdAt)),
        }))}
        showExport
      />
    </Box>
  );
};

export default TableLogs;
